
import React, { Component } from 'react';
import './styles/player-controls-vod.css';
import logger from 'src/utils/logger/logger';
import TimeLabel from './common/TimeLabel';
import PlayerSlider from './common/PlayerSlider';
import VideoPlayerControl from './../components/common/VideoPlayerControl';
import {
    CONTROL_BACKWARD,
    CONTROL_FORWARD,
    CONTROL_PLAY,
    CONTROL_PAUSE,
    CONTROL_LANGUAGE,
    CONTROL_SERIE,
    CONTROL_FAVORITE,
    CONTROL_UNFAVORITE
} from './common/constants';
import { setSeekInterval } from './seekIntervalUtil';
import TrackerManager from '../../utils/TrackerManager';
import PlayerControlsLogic from './PlayerControlsLogic';
import { AAF_CONTENT_IS_VOD } from './../../AAFPlayer/constants';
import Utils from '../../utils/Utils';
import { playerSettings } from './common/constants';
import Translator from '../../requests/apa/Translator';
import VODInfoLabel from './common/VODInfoLabel';
import { setEventData } from '../../components/Modal/ModalTimeOutEvent'
import settings from '../../devices/all/settings';
import { Grid, Row, Column, cls } from '../../packages/components';
import { fetchFavoriteLoader} from '../../requests/loader';
import store from '../../store';
import favoriteDelTask from '../../requests/tasks/ficha/favoriteDelTask';
import favoriteTask from '../../requests/tasks/ficha/favoriteTask';
import RequestManager from '../../requests/RequestManager';
import UpdateFavoriteVODObserver from '../../AAFPlayer/helpers/UpdateFavoriteVODObserver'
import { setLastTouchFavorited, setLastTouchSeen } from './../../reducers/user';
import { updateValuesStorageMount,
  updateValuesStorageUnMount } from 'src/components/Modal/functions/ModalInactivity/index'
import Asset from '../../requests/apa/Asset';
class PlayerControlsVod extends Component {

    constructor(props) {
        super(props);

        this.backward = this.backward.bind(this);
        this.forward = this.forward.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.onLanguage = this.onLanguage.bind(this);
        this.onSerie = this.onSerie.bind(this);

        this.state = {
            serieData: null,
            isFavorite: false,
            toggle: true,
        };

        this.defaultButtons = [
            { type: CONTROL_BACKWARD, clic: this.backward, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_rewind', 'Atrasar') },
            { type: CONTROL_PAUSE, clic: this.handleClickPlayPauseButton, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_pause', 'Pausa')},
            { type: CONTROL_FORWARD, clic: this.forward, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_forward', 'Adelantar') },
            { type: CONTROL_LANGUAGE, clic: this.onLanguage, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_language', 'Idioma') },
        ];
        this.visibleButtons = [];

        this.addEventListeners = this.addEventListeners.bind(this);
        this.removeEventListeners = this.removeEventListeners.bind(this);
        this.slide = this.slide.bind(this);
        this.updateCurrentTimeUI = this.updateCurrentTimeUI.bind(this);
        this.updateCurrentTime = this.updateCurrentTime.bind(this);
        this.sendFowardRewindSeek = this.sendFowardRewindSeek.bind(this);
        this.showSprites = this.showSprites.bind(this);
        this.hideSprites = this.hideSprites.bind(this);
        this.handleEndPlayer = this.handleEndPlayer.bind(this);
        this.toggleFavorite = this.toggleFavorite.bind(this);
        this.getVisibleButtons = this.getVisibleButtons.bind(this);
        this.setContentTitle = this.setContentTitle.bind(this);
        this.checkFavoritedContent = this.checkFavoritedContent.bind(this);

        this.seekInPause = 0;
        this.seekTime = 0;
        this.isMoving = false;
        this.seekTotalTime = 0;
        this.currentTime = 0;
        this.data = {};

        this.timeoutTitleId = null;
        this.timeoutTitleMs = 3000;

        this.firstRender = true
        this.assetsControls = {}
        this.isFavoriteIsSet = false
        this.countRender = 0

        this.paramsModalSleep = {
          pause: this.pause,
          play: this.play,
          exit: this.props.onExit,
        };
        this.isSerie = store.getState().modalInactivity.isSerie;
        this.isPlaying = store.getState().player.playerstate === "PLAYING"
        this.setIntervalModalInactivity = this.isPlaying ? PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalSleep) :null;

        const that = this;
        this.seekBarInterval = setSeekInterval(function () {
            if (that.seekTotalTime >= 0 && that.isMoving) {
                logger.debug('[NPC] interval seek', that.seekTotalTime);
                //Send stats related to seek (i.e. sumologic)
                that.sendFowardRewindSeek();
                that.seek(that.seekTotalTime);
                that.seekTotalTime = 0;
                that.seekTime = 0;
                that.isMoving = false;
                that.props.onIsMoving(false);
                // that.setTimer();
            }
            logger.debug('[PlayerControls] interval before stop after set seek ');
            this.stop();
        }, 2);
    }

    onLanguage() {
        this.props.onLanguage({
            title: this.data && this.data.contentTitleNormal || '',
            contentSerieEpisodeTitle: this.data && this.data.contentSerieEpisodeTitle || null,
            description: this.data && this.data.description || '',
            duration: this.data && this.data.duration || null
        });
    }

    updateCurrentTime(currentTime) {
        this.setCurrentTime(currentTime);
        if (!this.isMoving) {
            this.updateCurrentTimeUI(currentTime);
        }
    }

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
    }

    getCurrentTime() {
        return this.currentTime;
    }

    getDuration() {
        return this.props.getDuration();
    }

    getBallPosition(ballPercent) {
        if (this.refs['playerSlider']) {
            const width = this.refs['playerSlider'].refs['barContainer'].offsetWidth;
            if (width < 1) return 0;
            const left = (width * ballPercent) / 100;

            return left;
        }

        return 0;
    }

    updateCurrentTimeUI(currentTime) {
        const ballPercent = PlayerControlsLogic.getPercentProgress(currentTime, this.getDuration());
        if (this.refs['playerSlider']) {
            // % barra avance
            this.refs['playerSlider'].refs['progressNow'].style.width = ballPercent + '%';
            // Time start
            this.refs['timeStart'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(currentTime, AAF_CONTENT_IS_VOD);
            // Ball position
            this.refs['playerSlider'].refs['ball'].style.left = this.getBallPosition(ballPercent) + 'px';
            // Time end
            // console.log('[NPC] PlayerControls this.refs[playerControls].refs[timeEnd].refs[time].innerHTML', this.refs['playerControls'].refs['timeEnd'].refs['time'].innerHTML);
            this.refs['timeEnd'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(this.getDuration(), AAF_CONTENT_IS_VOD);
            // this.props.contentSprite && this.props.updateCurrentTimeSprite(currentTime);
            this.props.contentSprite && this.props.updateSpritePosition();
        }
    }

    sendFowardRewindSeek() {
        logger.debug('[NPC] SEND STATS SEEK');
        const { isBackward, seekTime } = this.getOperatorsSeek();

        if (isBackward && (seekTime === 15 || seekTime === 10)) {
            TrackerManager.rewind(this.getCurrentTime());
        } else if (!isBackward && (seekTime === 15 || seekTime === 10)) {
            TrackerManager.foward(this.getCurrentTime());
        }
    }

    /**
     * Resolve enabled buttons
     */

    getVisibleButtons() {
        const user = store.getState().user;
        const { ispreview } = this.props;
        let visible = []

        if(Utils.isPlaystation4()) {
            visible = [...this.defaultButtons]
        } else {
            visible = this.defaultButtons.map((button) => {
                if (button.type === CONTROL_PAUSE || button.type === CONTROL_PLAY) {
                    return {
                        ...button,
                        type: this.state.toggle ? CONTROL_PAUSE : CONTROL_PLAY,
                        title: this.state.toggle
                            ? Translator.get('playing_playerControls_toolbar_button_pause', 'Pausa')
                            : Translator.get('playing_playerControls_toolbar_button_play', 'Reproducir'),
                    };
                }

                return button;
            });
        }


        const followText = Translator.get('playing_playerControls_toolbar_button_addList', 'Agregar a Mi Lista');
        const unfollowText = Translator.get('playing_playerControls_toolbar_button_deleteList', 'Quitar de Mi Lista');

        const isSerie = this.state.serieData && !ispreview;

        if (!user.isAnonymous && !isSerie) {
            visible.push({ type: this.state.isFavorite ? CONTROL_UNFAVORITE : CONTROL_FAVORITE, clic: this.toggleFavorite, enabled: true, title: this.state.isFavorite ? unfollowText : followText })
        }

        if (isSerie) {
            visible.push({ type: CONTROL_SERIE, clic: this.onSerie, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_seasons', 'Temporadas') });
            visible.push({ type: this.state.isFavorite ? CONTROL_UNFAVORITE : CONTROL_FAVORITE, clic: this.toggleFavorite, enabled: true, title: this.state.isFavorite ? unfollowText : followText })
        }

        return visible;
    }

    onSerie() {
        const { group_id = null, contentTitleNormal = '' } = this.data;
        this.props.onSerie(group_id, contentTitleNormal);
    }

    addEventListeners() {
        this.removeEventListeners();
        document.addEventListener(settings.end_vod_fire_event, this.handleEndPlayer);
    }

    removeEventListeners() {
        document.removeEventListener(settings.end_vod_fire_event, this.handleEndPlayer);
    }

    handleEndPlayer() {
        this.props.hideAll();
    }

    /**
   * Slider side actions
   * @param e
   */
    slide(e) {
        logger.debug('[NPC] Playercontrols slide events');
        if (!this.props.enabled) return;

        // Reset autohide
        this.props.onSlide(null, direction);

        const { direction } = e.detail;
        switch (direction) {
            case 'left':
                e.preventDefault();
                this.calculateFinalSeekTime(true, playerSettings.slideTime);
                break;
            case 'right':
                e.preventDefault();
                this.calculateFinalSeekTime(false, playerSettings.slideTime);
                break;
            default:
                break;
        }
    }

    forward() {
        if (!this.props.enabled) return;
        this.props.onForward(null);
        this.calculateFinalSeekTime(false, playerSettings.forwardTime);
    }

    backward() {
        if (!this.props.enabled) return;
        this.props.onBackward(null);
        this.calculateFinalSeekTime(true, playerSettings.backwardTime);
    }

    toggleAssetsButton(imgId, imgBase64, labelId, label) {
        const anchor = document.querySelector(imgId);
        const img = anchor.querySelector('img');
        img.src =  imgBase64

        const divTitle = document.querySelector(labelId)
        divTitle.innerHTML = label

    }

    /**
    * Controles del player
    */
    play() {
        if (!this.props.enabled) return;
        try {
            this.props.play();
            this.props.onPlay(() => {
                if (this.props.visible) this.props.focus('.video-player-control-main-button-pause');
                if (this.seekInPause) {
                    Utils.seekInPause(this.props.seek, this.seekInPause);
                    this.seekInPause = 0;
                }
            });
            if (Utils.isTimeoutAvailable()) {
                const { clearTimeOutAAF = () => { } } = this.props;
                clearTimeOutAAF();
            }
        } catch (err) {
            logger.error('[ playercontrols - error on play ] ',err)
        }

    }

    pause() {
        if (!this.props.enabled) return;
        try {
            this.props.pause();
            this.props.onPause(this.getCurrentTime(), () => {
                this.props.focus('.video-player-control-main-button-play');
            });
            if (Utils.isTimeoutAvailable()) {
                const { startTimeOutAAF = () => { } } = this.props;
                startTimeOutAAF();
            }
        } catch (err) {
            logger.error('[ playercontrols - error on pause ] ',err)
        }
    }

    handleClickPlayPauseButton = () => {
        if(this.state.toggle) this.pause()
        else this.play()
        this.setState(prev => ({
            toggle: !prev.toggle
        }));

        if(Utils.isPlaystation4()) {
            this.toggleAssetsButton(
                '#pc1',
                !this.state.toggle ? this.assetsControls[CONTROL_PAUSE].img : this.assetsControls[CONTROL_PLAY].img,
                '#video_control_title',
                !this.state.toggle ? this.assetsControls[CONTROL_PAUSE].title : this.assetsControls[CONTROL_PLAY].title
            )
        }
    }

    async checkFavoritedContent(groupId) {
        const user = store.getState().user;
        const filterList = Utils.getAPAFilterList();
        const favs = await fetchFavoriteLoader(user, filterList);
        if (
          favs &&
          favs.response &&
          favs.response &&
          favs.response.groups &&
          Array.isArray(favs.response.groups)
        ) {
          const favoritedContent = favs.response.groups.find(el => el.id == groupId);
          this.firstRender = true
          this.setState({isFavorite: favoritedContent && typeof favoritedContent == 'object'});
        }
        return new Promise(resolve => resolve(true));
    };

    deleteFavorite = () => {
        const user = store.getState().user;
        const p = {
          object_id: this.data.group_id,
          object_type: 1,
          user_hash: user ? user.session_userhash : null
        };
        const params = new favoriteDelTask(p);
        RequestManager.addRequest(params)
          .then(data => {
            const responseData = data.data;
            if (responseData && responseData.delete) {
              // Actualizar favoritos y seen con el mismo valor de favorited (para que lo tome level-user)
              if (responseData.lasttouch && responseData.lasttouch.favorited) {
                const lastTouchFav = responseData.lasttouch.favorited;
                store.dispatch(setLastTouchSeen(lastTouchFav));
                store.dispatch(setLastTouchFavorited(lastTouchFav));
              }
            }
          })
          .catch(e => {
            logger.error(e);
          });
      };

    addToFavorite = () => {
        const user = store.getState().user;
        const p = {
            object_id: this.data.group_id,
            object_type: 1,
            user_hash: user.session_userhash
        };

        const params = new favoriteTask(p);
        RequestManager.addRequest(params).then(data => {
            // Actualizar favoritos y seen con el mismo valor de favorited
            if (data && data.data && data.data.lasttouch && data.data.lasttouch.favorited) {
                const lastTouchFav = data.data.lasttouch.favorited;
                store.dispatch(setLastTouchSeen(lastTouchFav));
                store.dispatch(setLastTouchFavorited(lastTouchFav));
            }
        })
        .catch(e => {
            logger.error(e);
        });
    };

    toggleFavorite() {
        const isFavorite = !this.state.isFavorite;
        if(isFavorite) this.addToFavorite();
        else this.deleteFavorite();
        this.setState({ isFavorite })
        UpdateFavoriteVODObserver.emit("favorite", {isFavorite, groupId: this.data.group_id});
        if(Utils.isPlaystation4()) {
            this.toggleAssetsButton(
                this.isSerie ? '#pc5' : '#pc4',
                isFavorite ? this.assetsControls[CONTROL_UNFAVORITE].img : this.assetsControls[CONTROL_FAVORITE].img,
                '#favorite',
                isFavorite ? this.assetsControls[CONTROL_UNFAVORITE].title : this.assetsControls[CONTROL_FAVORITE].title
            )
        }
    }

    /**
    *
    */

    focusPlayPauseButton(btnClass) {
        this.props.focus(btnClass);
    }

    showSprites() {
        if (!this.props.contentSprite) return;
        if (this.timeoutTitleId) {
            clearTimeout(this.timeoutTitleId);
            this.timeoutTitleId = null;
        }
        this.setContentTitle({ title: '&nbsp;' }, false);
        this.props.showSprites(this.props.canShowSprites());
    }

    hideSprites() {
        if (!this.props.contentSprite) return;
        this.props.hideSprites()
        this.timeoutTitleId = setTimeout((() => {
            this.setContentTitle(this.data, false);
        }), this.timeoutTitleMs);
    }

    calculateFinalSeekTime(isBackward, seekTime) {
        if (!this.props.enabled) return;

        const spritesEnabled = this.props.contentSprite;
        if (spritesEnabled) {
            this.showSprites();
        }

        // TODO this.showSprites(this.canShowSprites());
        logger.debug(
            '[NPC] Vemos los nuevos tiempos que se tienen en el player  -isBackward - seekTime ',
            isBackward,
            seekTime
        );
        this.setOperatorsSeek({ isBackward, seekTime });
        // TODO Esto de abajo se debe hacer desde el class father para que muestre la barra
        // TODO this.show();
        let secs = isBackward ? -seekTime : seekTime;
        let curTime = this.getCurrentTime();
        if (this.seekInPause) {
            curTime = this.seekInPause;
        }
        let newSecs = curTime + (this.seekTime += secs);
        if (newSecs < 0) {
            newSecs = 0;
        }
        if (newSecs > this.getDuration()) {
            newSecs = this.getDuration() - 1;
        }
        logger.debug(
            '[NPC] calculateFinalSeekTime',
            '\nisBackward ' + isBackward,
            '\nnewSeekTime ' + seekTime,
            '\nseekTime ' + this.seekTime,
            '\nnewSecs ' + newSecs,
            '\ncurTime ' + curTime,
            '\nspritesEnabled ' + spritesEnabled,
        );
        this.updateCurrentTimeUI(newSecs);
        spritesEnabled && this.props.updateSprite(newSecs);
        this.doSeek(newSecs, curTime);
        spritesEnabled && this.hideSprites();
    }

    doSeek(newSecs, currentTime) {
        logger.debug(
            '[NPC] doSeek  ' + '-newSecs ' + newSecs,
            '- currentTime ' + currentTime
        );
        this.seekBarInterval.stop();
        this.seekBarInterval.start();
        this.isMoving = true;
        this.props.onIsMoving(true);
        this.seekTotalTime = newSecs;
    }

    seek(time) {
        /**
         * De acuerdo a este commit https://bitbucket.org/dlaargentina/stvreact/commits/9c72921b8d5978e76ad2046d184004a0da4c2122
         * si el player está en currenttime 0, se oculta playerControls (this.hide() y se pone la bandera this.isVisible = false).
         *
         * Pero esto de arriba no permite que se haga un seek a 0 en los primeros 29 segundos de reproducción
         * porque al hacer el seek al time=0 la bandera isVisible ya está en false, por tanto el seek no lo hace.
         * Se agrega validación extra para forzar seek en 0 (con doSeek var de abajo)
         */
        let doSeek = this.props.visible;
        if (time < 1 && !this.props.visible) {
            doSeek = true;
        }

        if ((doSeek) && this.props.enabled) {
            if (!this.state.toggle) {
                this.seekInPause = time;
                this.setCurrentTime(this.seekInPause);
            } else {
                this.props.seek(time);
            }
        }
    }

    setOperatorsSeek(values) {
        this.valuesSeek = { ...values };
    }

    getOperatorsSeek() {
        return this.valuesSeek;
    }

    async setContentTitle(contentTitle, saveData = true) {
        setEventData(contentTitle);

        if (this.refs['vodInfoLabel'] && contentTitle.title) {
            const data = { ...contentTitle };
            if (saveData) {
                this.checkFavoritedContent(contentTitle.group_id);
                this.data = contentTitle;
            }
            if (this.refs['vodInfoLabel'].refs['vodEventTitle']) this.refs['vodInfoLabel'].refs['vodEventTitle'].innerHTML = Utils.cutPlayerString(data.title, 70, 67);
        }
    }

    getDataContentTitle() {
        return this.data;
    }



    async getAssetsControls() {
        const assetPlayButton =  await Asset.get('playing_playerControls_toolbar_button_play');
        const titlePlay =  await  Translator.get('playing_playerControls_toolbar_button_play', 'Reproducir')

        const assetPauseButton = await Asset.get('playing_playerControls_toolbar_button_pause');
        const titlePause =  await Translator.get('playing_playerControls_toolbar_button_pause', 'Pausa')

        const assetAddFavoritesButton = await Asset.get('playing_playerControls_toolbar_button_addList');
        const titleAddFavorites = await Translator.get('playing_playerControls_toolbar_button_addList', 'Agregar a Mi Lista')

        const assetRemoveFavoritesButton = await Asset.get('playing_playerControls_toolbar_button_deleteList');
        const titleRemoveFavorites = await Translator.get('playing_playerControls_toolbar_button_deleteList', 'Quitar de Mi Lista')

        return {
            [CONTROL_PLAY]: {
                img: assetPlayButton,
                title: titlePlay
            },
            [CONTROL_PAUSE]: {
                img: assetPauseButton,
                title: titlePause
            },
            [CONTROL_FAVORITE]: {
                img: assetAddFavoritesButton,
                title: titleAddFavorites
            },
            [CONTROL_UNFAVORITE]: {
                img: assetRemoveFavoritesButton,
                title: titleRemoveFavorites
            }
        }
    }

    async componentWillReceiveProps(nextProps) {
        if(!this.setIntervalModalInactivity){
        await updateValuesStorageMount(AAF_CONTENT_IS_VOD)
        this.setIntervalModalInactivity = this.modalInactivityEnabled ? PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalSleep) : null;
      }
        this.setState({ serieData: nextProps.serieData });

        this.countRender = this.countRender + 1


        if (nextProps.serieData) {
          this.isSerie = true;
          PlayerControlsLogic.setValueStatePlaying({ isSerie: true});
        }else{
          this.isSerie = false;
          PlayerControlsLogic.setValueStatePlaying({ isSerie: false});
        }
    }

    async componentDidMount() {
        try{
            if (Utils.isPlaystation4()) this.assetsControls = await this.getAssetsControls();
            await updateValuesStorageMount(AAF_CONTENT_IS_VOD)
            this.addEventListeners();
        }catch(error){
            logger.debug('componentDidMount-error', error)
        }
    }

    componentWillUnmount() {
        clearInterval(this.setIntervalModalInactivity)
        !this.isSerie && updateValuesStorageUnMount(this.setIntervalModalInactivity)
        this.removeEventListeners();
    }

    render() {
        if(!Utils.isPlaystation4()) this.visibleButtons = this.getVisibleButtons();

        if(this.firstRender && Utils.isPlaystation4() && this.countRender > 1) {
            this.visibleButtons = this.getVisibleButtons()
            this.firstRender = false
        }

        let defLength = 3;
        let controlsClassName = '';
        if(Array.isArray(this.visibleButtons)) {
            defLength = this.visibleButtons.length;
            controlsClassName = `player-controls-width-${defLength}`;
        }

        let ct = 1;
        return (
            <div>
                <Grid className={cls(`player-controls-vod-container`)}>
                    <Row className={cls(`player-controls-vod-channelinfo-wrapper`)}>
                        <VODInfoLabel ref="vodInfoLabel" />
                    </Row>
                    <Row className={cls(`player-controls-vod-flex-slider-wrapper`)}>
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel ref="timeStart" />
                        </Column>
                        {/* La barra Bar Total es la que muestra en un startover, la que muestra el progress del evento respecto al now.  */}
                        <Column lg={10} className={cls(``)}>
                            <PlayerSlider
                                ref="playerSlider"
                                withBarTotal={false}
                                slide={this.slide}
                                ballPercent={this.props.ballPercent}
                            />
                        </Column>
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel customCss="time-label-custom-end" ref="timeEnd" />
                        </Column>
                    </Row>
                    <Row className={cls(``)}>
                        <div className="player-controls-vod-separator"></div>
                    </Row>
                </Grid>
                <Grid className={cls(`player-controls-vod-no-grid-float`)}>
                    <Row className={cls(`player-controls-vod-flex-controls-wrapper ${controlsClassName}`)}>
                        {
                            this.visibleButtons.map((button, idx, items) => <VideoPlayerControl
                                control={button}
                                onClic={button.clic}
                                key={`control_${ct++}`}
                                id={`pc${idx}`}
                                nav={this.props.getPlayerControlsButtonNavigation(idx, items, true)}
                                typeContent={"vod"}
                            />
                            )
                        }
                    </Row>
                </Grid >
            </div>
        )
    }
}

export default PlayerControlsVod;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsVod.js